import classNames from "classnames";
import { SingletonRouter } from "next/router";
import React, { useEffect } from "react";
import { defineMessages, useIntl } from "react-intl";

import { formattedMessageParams } from "shared/messages";
import FlightOffer from "shared/types/flightOffer";

import BrandsModal from "@components/Flights/BrandedFares/BrandsModal";
import FormattedMessage from "@components/UI/FormattedMessage";
import Modal from "@components/UI/Modal";

interface IMoreBrandsButton {
  flightOffer: FlightOffer;
  getRefsForFlightOffer: () => string[];
  url: SingletonRouter;
  currency: string;
  setIsSomeModalOpenned: React.Dispatch<React.SetStateAction<boolean>>;
}

const MoreBrandsButton: React.FC<IMoreBrandsButton> = (props) => {
  const [showModal, setShowModal] = React.useState(false);
  const [showVerticalScrollBar, setShowVerticalScrollBar] = React.useState(
    false
  );
  const [showHorizontalScrollBar, setShowHorizontalScrollBar] = React.useState(
    false
  );

  useEffect(() => {
    if (props?.setIsSomeModalOpenned) {
      props.setIsSomeModalOpenned(showModal);
    }
    // eslint-disable-next-line
  }, [showModal]);

  const intl = useIntl();

  const hideModal = () => {
    setShowModal(false);
  };

  const { modalTitle } = defineMessages({
    modalTitle: formattedMessageParams("BrandedFares.ModalTitle"),
  });

  return (
    <>
      <div
        role="tab"
        className="flight-offer-brand"
        onClick={() => setShowModal(true)}
      >
        <div className="flight-offer-brand-nameicon-wrapper">
          <button
            type="button"
            className={classNames("more-brands-link", {
              active: showModal,
            })}
          >
            <FormattedMessage id="BrandedFares.MoreBrandsTab" />
          </button>
        </div>
      </div>
      {showModal ? (
        <Modal
          isActive
          onClose={hideModal}
          className={classNames(
            { "branded-fares-modal": true },
            { "show-vertical-scrollbar": showVerticalScrollBar },
            { "show-horizontal-scrollbar": showHorizontalScrollBar }
          )}
          modalTitle={intl.formatMessage(modalTitle)}
          setShowVerticalScrollBar={setShowVerticalScrollBar}
          setShowHorizontalScrollBar={setShowHorizontalScrollBar}
        >
          <BrandsModal {...props} />
        </Modal>
      ) : null}
    </>
  );
};

export default MoreBrandsButton;
